import React, {useEffect, useState} from "react";
import {getFileUrl, getThumbUrl} from "../../config";
import {Avatar} from "@material-tailwind/react";
import {BsDownload} from "react-icons/bs";

/*
* TODO: add an image preview for files with image type using a modal having download button
* */
function FileCell({fileCode}) {
    const [hovered, setHovered] = useState(false);
    const [thumb, setThumb] = useState(null)

    const handleMouseEnter = () => {
        setHovered(true);
    };

    const handleMouseLeave = () => {
        setHovered(false);
    };

    useEffect(() => {
        async function getData() {
            const result = await getThumbUrl(fileCode);
            setThumb(result);
        }

        getData()
    }, [fileCode]);

    if (thumb) {
        return (
            <div
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                style={{position: 'relative'}}
                className="text-center"
            >
                <Avatar
                    src={thumb}
                    alt="nature image"
                    style={{cursor: 'pointer', filter: hovered ? 'blur(2px)' : 'none'}}
                    variant="rounded"
                    size="md"
                    // onClick={() => {
                    //   window.open(getFileUrl(fileCode), "_blank");
                    // }}
                />
                {hovered && (
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                            borderRadius: '50%',
                            padding: '8px',
                            cursor: 'pointer',
                        }}
                        className={"items-center"}
                        onClick={() => {
                            window.open(getFileUrl(fileCode), '_blank');
                        }}
                    >
                        <BsDownload size={24}/>
                    </div>
                )}
            </div>
        );
    }
}

export default FileCell;